import { PriorityLevelRequest as ApiPriorityLevelRequest, PriorityLevelResponse } from "lib-klab-sdks";
import { PriorityLevel, PriorityLevelRequest } from "../../../domain/models/requirement/priority-level.model";

export function mapPriorityLevel(source: PriorityLevelResponse): PriorityLevel {
  return {
    id: source.priorityLevelId,
    code: source.code,
    name: source.name,
    requiresJustification: source.requiresJustification,
    requiresEvidence: source.requiresEvidence,
    sortOrder: source.sortOrder,
    colorHex: source.colorHex,
    statusId: source.statusId,
    createdAt: source.createdAt,
    updatedAt: source.updatedAt,
  };
}

export function mapPriorityLevelRequest(source: PriorityLevelRequest): ApiPriorityLevelRequest {
  return { ...source };
}
